<div class="white-box">
    <div
            class="tab-pane fade"
            id="reviews"
            role="tabpanel"
            aria-labelledby="review-tab"
    >
        <div class="booking-table-container">
            <div class="sort-wrapper">
                <div class="error-list" v-if="ui.error.error_message">
                    <ul class="error-msg">
                        <li v-for="(error,x) in ui.error.error_message" :key="x">
                            <div v-for="(err,i) in error" :key="i">
                                <p>{{ err }}</p>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>

            <div class="table-responsive">
                <table class="table" id="example">
                    <thead class="table-light-bg" v-if="item.reviewsList">
                    <tr>
                        <th scope="col">Name</th>
                        <th scope="col">Title<i class="fas fa-chevron-down"></i></th>
                        <th scope="col">Review <i class="fas fa-chevron-down"></i></th>

                        <th scope="col">Date</th>
                        <th scope="col">Rating <i class="fas fa-chevron-up"></i></th>

                        <th scope="col">Action</th>
                    </tr>
                    </thead>
                    <tbody>

                    <tr
                            v-if="item.reviewsList"
                            v-for="(review, index) in item.reviewsList"
                            :key="index"
                    >
                        <td>
                            <div class="review-image">
                                <img src="img/user.jpg" alt="" />
                            </div>

                            <div class="review-name">
                                <h5 v-if="review.customer">
                                    {{ review.customer.full_name }}
                                </h5>
                                <p v-if="review.customer">
                                    {{ review.customer.email }}
                                </p>
                            </div>
                        </td>
                        <td v-if="review.title">
                            {{ review.title }}
                        </td>

                        <td v-if="review.description">{{ review.short_review }}</td>
                        <td v-else>-</td>

                        <td v-if="review.review_date">
                            {{ review.review_date }}
                        </td>
                        <td v-else>-</td>
                        <td>
                            <div class="review-star">
                                <star-rating
                                        v-model="review.rating"
                                        :increment="0.5"
                                        :read-only="true"
                                ></star-rating>
                            </div>
                        </td>
                        <td>
                            <div class="includes-action justify-content-start">
                                <button
                                        type="button"
                                        class="btn green"
                                        data-toggle="modal"
                                        data-target="#review-modal"
                                        @click.prevent="onViewReviewClick(review)"
                                >
                                    <i class="fas fa-eye"></i>
                                </button>
                            </div>
                        </td>
                    </tr>
                    <tr v-else></tr>
                    </tbody>
                </table>
                <div v-if="item.reviewsList ==0" class="empty-data">
                    <p>
                        No comments
                    </p>
                </div>
            </div>
            <Pager @onPaging="onPaging" :pager="ui.paging"></Pager>

            <div class="spinner">
                <moon-loader
                        v-if="item.reviewsList"
                        :loading="ui.status.isLoading.getReviewList"
                        :size="50"
                ></moon-loader>
            </div>
        </div>
    </div>

    <!-- Modal -->
    <div class="modal-wrap">
        <div
                class="modal fade show"
                id="review-modal"
                tabindex="-1"
                role="dialog"
                aria-labelledby="exampleModalLabel"
        >
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Review</h5>
                        <button
                                type="button"
                                class="close"
                                data-dismiss="modal"
                                aria-label="Close"
                        >
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="review-block py-2">
                            <div class="review-image">
                                <img src="img/user-img.png" alt="" />
                            </div>
                            <div class="review-name">
                                <h5>
                                    {{ item.selectedReview.customer.full_name }}
                                </h5>
                                <p>{{ item.selectedReview.customer.email }}</p>
                            </div>
                            <div class="review-date">
                                <p>
                                    <span v-if="item.selectedReview.customer.country">From</span>
                                    <span>{{ item.selectedReview.customer.country }}</span> on
                                    <span>{{ item.selectedReview.review_date }}</span>
                                </p>
                            </div>
                            <div class="review-text">
                                <p>" {{ item.selectedReview.description }} "</p>
                            </div>

                            <div class="rating-block">
                                <p class="mb-1">Rating</p>
                                <div class="review-star">
                                    <star-rating
                                            v-model="item.selectedReview.rating"
                                            :increment="0.5"
                                            :read-only="true"
                                    ></star-rating>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
